import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import UserDataTable from './UserDataTable';
import UserTableFooter from './UserTableFooter';
import { useUserTableColumns } from '../config/userTableConfig';

export default function UserListTable({
  users,
  loading,
  page,
  pageSize,
  totalCount,
  showSuperuserColumns,
  onEdit,
  onChangePassword,
  onUnlock,
  onDeactivate,
  onActivate,
  onDelete,
  onOrganisationClick,
  onProfileClick,
  onPageChange,
  onPageSizeChange,
}) {
  const columns = useUserTableColumns({
    page,
    pageSize,
    showSuperuserColumns,
    onEdit,
    onChangePassword,
    onUnlock,
    onDeactivate,
    onActivate,
    onDelete,
    onOrganisationClick,
    onProfileClick,
  });

  const initialState = useMemo(
    () => ({
      density: 'compact',
      columnPinning: { right: ['actions'] },
    }),
    []
  );

  return (
    <UserDataTable
      columns={columns}
      data={users}
      getRowId={(row) => String(row.id ?? row.username)}
      enableColumnPinning
      enableDensityToggle={false}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableColumnFilters={false}
      enableHiding={false}
      enablePagination={false}
      enableBottomToolbar
      initialState={initialState}
      state={{ isLoading: loading && users.length === 0 }}
      renderBottomToolbar={() => (
        <UserTableFooter
          count={totalCount}
          page={page}
          pageSize={pageSize}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      )}
    />
  );
}

UserListTable.propTypes = {
  users: PropTypes.array,
  loading: PropTypes.bool,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  totalCount: PropTypes.number,
  showSuperuserColumns: PropTypes.bool,
  onEdit: PropTypes.func,
  onChangePassword: PropTypes.func,
  onUnlock: PropTypes.func,
  onDeactivate: PropTypes.func,
  onActivate: PropTypes.func,
  onDelete: PropTypes.func,
  onOrganisationClick: PropTypes.func,
  onProfileClick: PropTypes.func,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
};
